import { fetchWrapper } from '../../fetch';
import { baseURL, deserialize } from '../../helpers';
import type { PigeonRegion, PigeonUser } from './interface';

function pigeonUsersUrl(path: string): string {
  return new URL(`/api/v1/file-share-users${path}`, baseURL).href;
}

async function post(path: string, body: object): Promise<void> {
  const response = await fetchWrapper(pigeonUsersUrl(path), {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  await deserialize(response);
}

const pigeonUsersApiClient = {
  list: async (): Promise<PigeonUser[]> => {
    const response = await fetchWrapper(pigeonUsersUrl(''), {
      method: 'GET',
      credentials: 'include',
    });
    return deserialize(response);
  },
  invite: (user: { email: string; region: PigeonRegion }): Promise<void> =>
    post('', user),
  resendInvite: (email: string): Promise<void> => post('/resend', { email }),
  removeAccess: (email: string): Promise<void> => post('/disable', { email }),
  restoreAccess: (email: string): Promise<void> => post('/enable', { email }),
};

export default pigeonUsersApiClient;
